import { render, staticRenderFns } from "./RegisterWizardStepTwo.vue?vue&type=template&id=1ed7188c&scoped=true"
import script from "./RegisterWizardStepTwo.vue?vue&type=script&lang=js"
export * from "./RegisterWizardStepTwo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed7188c",
  null
  
)

export default component.exports